module.exports = __webpack_public_path__ + "img/node.6ea13095.png";